<template>
	<div>
		<Head :title="$t('home.app_action.title')" :iconUrl="require('@/assets/images/certife/app_visit.png')" />

		<div class="search">
			<div>
				<a-date-picker
					style="width: 300px"
					v-model="searchForm.loginTime"
					@change="getList(1)"
					valueFormat="YYYY-MM-DD"
					:placeholder="$t('home.account_certify.date_search')"
				/>
			</div>
			<div>
				<a-select
					v-model="searchForm.appId"
					@change="getList(1)"
					style="width: 300px"
					:placeholder="$t('home.app_action.app_search')"
					allowClear
				>
					<a-select-option v-for="item in appOptions" :value="item.id" :key="item.id">{{ item.appName }}</a-select-option>
				</a-select>
			</div>
			<div>
				<a-select
					v-model="searchForm.message"
					@change="getList(1)"
					style="width: 300px"
					:placeholder="$t('home.app_action.result_search')"
					allowClear
				>
					<a-select-option value="success">{{ $t("home.account_certify.result_success") }}</a-select-option>
					<a-select-option value="fail">{{ $t("home.account_certify.result_failure") }}</a-select-option>
				</a-select>
			</div>
			<div>
				<a-button type="primary" icon="reload" @click="handleReset">{{ $t("base.btn.reset") }}</a-button>
			</div>
		</div>

		<List
			:pagination="pagination"
			addTitle=""
			ref="table"
			:loading="loading"
			:columns="columns"
			:isChecked="false"
			:dataSource="dataSource"
			@handleTableChange="handleTableChange"
		>
			<!-- 认证结果 -->
			<template v-slot:message="{ text }">
				<span v-if="text == 'success'" style="color: #6BD31C"><a-icon type="check" /> {{ $t("home.account_certify.result_success") }}</span>
				<span v-else style="color: #FF0000"><a-icon type="exclamation-circle" /> {{ $t("home.account_certify.result_failure") }}</span>
			</template>
		</List>
	</div>
</template>

<script>
import Head from "../../compontents/Head";
import List from "@/components/public/list/ant";
import { deepClone } from "@/utils/deepclone";
import pagination from "@/utils/pagination";
import { commonAPI } from "@/apis";

export default {
	name: "appvisit",
	components: { Head, List },

	data() {
		return {
			searchForm: { appId: undefined, loginTime: "", message: undefined },
			pagination: deepClone(pagination),
			columns: [
				{ title: this.$t("home.app_action.columns.access_time"), dataIndex: "loginTime", key: "loginTime", align: "center" },
				{ title: this.$t("home.app_action.columns.app_name"), dataIndex: "appName", key: "appName", align: "center" },
				{
					title: this.$t("home.app_action.columns.result"),
					dataIndex: "message",
					key: "userId",
					align: "center",
					scopedSlots: { customRender: "message" },
				},
			],
			appOptions: [],
			dataSource: [],
			loading: false,
		};
	},
	created() {
		this.getAppList();
		this.getList();
	},
	methods: {
		// 获取应用列表
		async getAppList() {
			const { code, data } = await commonAPI.getAction("/appList");
			if (code == 0) {
				this.appOptions = data || [];
			}
		},
		// 获取列表
		async getList(current) {
			if (current == 1) {
				this.pagination.current = 1;
			}
			let params = {
				pageNumber: this.pagination.current,
				pageSize: this.pagination.pageSize,
				...this.searchForm,
			};
			this.loading = true;
			const { code, data } = await commonAPI.getAction("/historys/loginAppsHistory/fetch", params);
			if (code === 0) {
				this.dataSource = data.rows || [];
				this.pagination.total = data.total;
			}
			this.loading = false;
		},
		//   分页方法
		handleTableChange(pagination) {
			this.pagination = pagination;
			this.getList();
		},
		// 重置
		handleReset() {
			this.searchForm = { appId: undefined, loginTime: "", message: undefined };
			this.getList(1);
		},
	},
};
</script>

<style lang="less" scoped>
.search {
	display: flex;
	margin-top: 20px;
	align-items: center;
	& > div {
		margin-right: 10px;
	}
}
</style>
